var map = {
	"./Home-96.png": 1306,
	"./Hotels-96.png": 1307,
	"./Invoice-96.png": 1308,
	"./Office-Phone-96.png": 1309,
	"./Quotation-96.png": 1310,
	"./admins.png": 1311,
	"./articles.png": 367,
	"./attributes.png": 552,
	"./bills.png": 1312,
	"./bookings.png": 1313,
	"./calendar.png": 1314,
	"./chat.png": 1315,
	"./conversations.png": 1316,
	"./customer-affiliates.png": 1317,
	"./customer-buyers.png": 1318,
	"./customer-sellers.png": 1319,
	"./customers.png": 1320,
	"./field-latex-sell-on-cash.png": 1321,
	"./latex-sales-2.png": 1322,
	"./noteSettings.png": 1323,
	"./places.png": 1324,
	"./products.png": 1325,
	"./purchases-2.png": 1326,
	"./purchases.png": 1327,
	"./reports.png": 1328,
	"./rubber-debtors.png": 1329,
	"./rubber-payments.png": 1330,
	"./rubber-products.png": 1331,
	"./rubber-receipt.png": 762,
	"./rubber-receivables.png": 553,
	"./rubber-reports.png": 554,
	"./rubber-sales-2.png": 1332,
	"./rubber-sales.png": 1333,
	"./rubber-sheet-contract.png": 763,
	"./rubber-sheet-deposit.png": 764,
	"./rubber-sheet-make.png": 1334,
	"./rubber-sheet-sell-on-cash.png": 1335,
	"./rubber-sheet-stock.png": 555,
	"./rubber-sheet.png": 1336,
	"./sales-notes.png": 1337,
	"./sales.png": 1338,
	"./sell-online.png": 546,
	"./services.png": 1339,
	"./settings.png": 1340,
	"./sites.png": 1341,
	"./tasks.png": 1342,
	"./tours.png": 1343,
	"./tours2.png": 1344,
	"./users.png": 1345,
	"./vouchers.png": 551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 761;